import React from 'react';
import Vimeo from '@u-wave/react-vimeo';

class Picture extends React.Component {
  handleImageLoaded() {
    if(typeof this.props.handleCoverLoaded === 'function') {
      this.props.handleCoverLoaded();
    }
  }

  render() {
    const data = this.props.data;
    // console.log(data);
    const video = this.props.video;
    console.log(video);

    if(video) {
      return (
        //<div className={`video-cnt ${this.props.width === 'Side-by-Side' ? this.props.width.toLowerCase(): ''} ${this.props.notmobile === 'Disable' ? 'mobile-no-no' : ''}`}>
        // { video !== undefined ?
          <Vimeo
            video={video}
            className={`project-video ${this.props.width ? this.props.width.toLowerCase() : ''} `}
            responsive={true}
            controls={false}
            muted={true}
            loop={true}
            autoplay
          />//:null

        // }
        //</div>
      );
    } else {
      return (
        <picture className={`${this.props.width === 'Side-by-Side' ? this.props.width.toLowerCase(): ''} ${this.props.notmobile === 'Disable' ? 'mobile-no-no' : ''}`}>
        { data !== undefined ?
          <img
            src={data.url}
            alt={data.description} className={`project-image ${this.props.width ? this.props.width.toLowerCase() : ''} `}
            onLoad={this.handleImageLoaded.bind(this)}
          />:null

        }
        </picture>
      );
    }


  }
}

export default Picture;



// WEBPACK FOOTER //
// ./src/scripts/components/picture.js